import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import "./AdminLayout.css";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const adminUser = JSON.parse(localStorage.getItem("adminUser"));

  const handleLogout = () => {
    localStorage.removeItem("adminUser");
    window.location.href = "/admin/login";
  };

  const canManageUsers =
    adminUser?.role === "admin" || adminUser?.role === "dev";

  return (
    <div className="admin-layout">

      {/* Mobile Header */}

      <header className="admin-mobile-header">
        <button
          className="admin-menu-toggle"
          onClick={() => setSidebarOpen(true)}
        >
          ☰
        </button>

        <img src="/assets/mean3-logo.png" alt="Mean3" />
      </header>


      {/* Mobile Overlay */}

      {sidebarOpen && (
        <div
          className="admin-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}


      {/* Sidebar */}

      <aside
        className={`admin-sidebar ${
          sidebarOpen ? "admin-sidebar-open" : ""
        }`}
      >

        <div className="admin-logo">

          <img src="/assets/mean3-logo.png" alt="Mean3" />

          <span>Admin Panel</span>

          {/* Mobile Close Button */}

          <button
            className="admin-sidebar-close"
            onClick={() => setSidebarOpen(false)}
          >
            ×
          </button>

        </div>


        {/* Current User */}

        <div className="admin-current-user">

          <strong>
            Username: {adminUser?.username}
          </strong>

          <span>
            Role: {adminUser?.role}
          </span>

        </div>


        <nav className="admin-nav">

          {/* BLOGS */}

          <Link
            to="/admin/blogs"
            className="admin-nav-link"
            onClick={() => setSidebarOpen(false)}
          >
            <span className="nav-icon">▦</span>

            <span>Blogs</span>
          </Link>


          {/* USERS */}

          {canManageUsers && (
            <Link
              to="/admin/users"
              className="admin-nav-link"
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">♙</span>

              <span>Users</span>
            </Link>
          )}

        </nav>


        <div className="admin-sidebar-footer">

          <span>Mean3 CMS</span>

          <small>
            Content Management
          </small>

        </div>


        <button
          onClick={handleLogout}
          className="logout-btn"
        >
          Logout
        </button>

      </aside>


      {/* Main Content */}

      <main className="admin-content">
        <Outlet />
      </main>

    </div>
  );
};

export default AdminLayout;